export default __webpack_public_path__ + "static/media/google.3ee6be4d.svg";